var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-toolbar",
        {
          staticClass: "mb-2",
          attrs: { color: "primary", dark: "", dense: "", elevation: "0" }
        },
        [_c("span", [_vm._v("Order Statuses")])]
      ),
      _c("v-data-table", {
        attrs: {
          items: _vm.orderStatusList,
          headers: _vm.headers,
          dense: "",
          loading: _vm.orderStatusGetting
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.id))]),
                  _c("td", [_vm._v(_vm._s(item.name))]),
                  _c("td", [_vm._v(_vm._s(item.created_at.dateFormat_ENUS()))]),
                  _c("td", [_vm._v(_vm._s(item.updated_at.dateFormat_ENUS()))])
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }